module.exports = __webpack_public_path__ + "img/vcontroller-show-btn4.f321ed95.png";